import { render, staticRenderFns } from "./separated-lots-item-column-fields.vue?vue&type=template&id=7fe2e847"
import script from "./separated-lots-item-column-fields.vue?vue&type=script&lang=js"
export * from "./separated-lots-item-column-fields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports